import { fetchRequest } from 'src/hooks/useAPIRequest'
import { API_ENDPOINTS } from 'src/routes/routes'

interface Params {
    username: string
}

const forgotPassword = async ({ username }: Params) => {
    return await fetchRequest(API_ENDPOINTS.FORGOT_PASSWORD, { method: 'POST', data: JSON.stringify({ username }) })
}

export default forgotPassword
